import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { Router, useLocation } from 'wouter';
import { AppSwitch } from './AppSwitch';
import { MantineConfig } from './patterns/mantine/MantineConfig';
import { telemetry } from './telemetry/Telemetry';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { refetchOnWindowFocus: false, networkMode: 'always' },
        mutations: { networkMode: 'always' },
    },
});

const journeyFor = (path: string): string => {
    if (path === '/login/register') return 'Sign Up';
    if (path === '/login') return 'Log in';
    if (/^\/BO\w+$/.test(path)) return 'Board link';
    if (path.startsWith('/direct-invite/')) return 'Direct invite';
    if (path === '/organizations/create') return 'Create organization';
    if (path === '/organizations/join') return 'Join organization';
    if (path.startsWith('/organizations')) return 'Organizations';
    return 'Unknown';
};

// Emit exactly one $pageview per view: on mount and on every wouter navigation.
// Renders nothing; must live inside <Router> so useLocation has context.
const PageviewTracker = () => {
    const [location] = useLocation();
    useEffect(() => {
        telemetry.pageview({ journey: journeyFor(location), path: location });
    }, [location]);
    return null;
};

export const App = () => {
    return (
        <MantineConfig>
            <QueryClientProvider client={queryClient}>
                <Router>
                    <PageviewTracker />
                    <AppSwitch />
                </Router>
            </QueryClientProvider>
        </MantineConfig>
    );
};
